// src/app/custom-title.strategy.ts
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { APP_TITLE } from '../../constants';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  constructor(private readonly titleService: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    const TITLE_SEPARATOR = ' | ';

    if (title !== undefined) {
      const prefixedTitle = `${APP_TITLE}${TITLE_SEPARATOR}${title}`;
      this.titleService.setTitle(prefixedTitle);
    }
  }
}
